/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListTeachersParams,
  PaginatedTeachers,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List teachers from first active group excluding current user
 */
export const listTeachers = (
    params?: MaybeRefOrGetter<ListTeachersParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedTeachers>(
      {url: `/teachers`, method: 'GET',
        params, signal
    },
      );
    }




export const getListTeachersQueryKey = (params?: MaybeRefOrGetter<ListTeachersParams>,) => {
    return [
    'teachers', ...(params ? [params] : [])
    ] as const;
    }


export const getListTeachersQueryOptions = <TData = Awaited<ReturnType<typeof listTeachers>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListTeachersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeachers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListTeachersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeachers>>> = ({ signal }) => listTeachers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTeachers>>, TError, TData>
}

export type ListTeachersQueryResult = NonNullable<Awaited<ReturnType<typeof listTeachers>>>
export type ListTeachersQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List teachers from first active group excluding current user
 */

export function useListTeachers<TData = Awaited<ReturnType<typeof listTeachers>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListTeachersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTeachers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTeachersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






